import { useContext, createContext, memo } from "react";

import { Select, MenuItem, TextField, FormControl, InputLabel, useTheme } from "@material-ui/core";
import { KeyboardArrowDown as KeyboardArrowDownIcon } from "@material-ui/icons";
import clsx from "clsx";

const FormikFormContext = createContext();

const useFormikForm = () => {
  const context = useContext(FormikFormContext);

  return context;
};

const FormikInput = (props) => {
  const { label, name, onChange, onBlur } = props;
  const formik = useFormikForm();
  const theme = useTheme();

  if (formik?.values[name] === undefined) return null;

  return (
    <div className="form-control-holder">
      {/* {label && <p className="form-title">{label}</p>} */}
      <TextField
        id={name}
        name={name}
        label={label}
        variant="filled"
        onChange={onChange ?? formik.handleChange}
        onBlur={onBlur ?? formik.handleBlur}
        value={formik.values[name]}
        fullWidth
        InputProps={{
          style: {
            backgroundColor: theme.colors.colorPrimaryGrey400,
            fontWeight: 700
          },
        }}
      />
      {formik.touched[name] || formik.errors[name]
        ? (<span className="form-error">{formik.errors[name]}</span>) : null}
    </div>
  );
};

const FormikSelect = (props) => {
  const { label, name, onChange, onBlur, options, defaultLabel = "Select One" } = props;
  const formik = useFormikForm();
  const theme = useTheme();

  if (formik?.values[name] === undefined) return null;

  return (
    <FormControl className="form-control-holder" variant="filled" fullWidth>
      <InputLabel>{label}</InputLabel>
      <Select
        IconComponent={KeyboardArrowDownIcon}
        // IconComponent={(props) => <KeyboardArrowDownIcon {...props} style={{ top: "calc(50% - 12px)" }} />}
        id={name}
        name={name}
        // displayEmpty
        className={clsx({ placeholder: !formik.values[name] })}
        onChange={onChange ?? formik.handleChange}
        onBlur={onBlur ?? formik.handleBlur}
        value={formik.values[name]}
        // style={{ width: "100%", paddingTop: "16px", paddingBottom: "12px" }}
        style={{ backgroundColor: theme.colors.colorPrimaryGrey400, fontWeight: 700 }}
      >
        <MenuItem value="" disabled>{defaultLabel}</MenuItem>
        {options?.map((item, i) => <MenuItem key={`${name}-${item.value}-${i}`} value={item.value}>{item.label}</MenuItem>)}
      </Select>

      {formik.touched[name] || formik.errors[name]
        ? (<span className="form-error">{formik.errors[name]}</span>) : null}
    </FormControl>
  );

  // return (
  //   <div className="form-control-holder">
  //     {label && <p className="form-title">{label}</p>}
  //     <Select
  //       IconComponent={(props) => <KeyboardArrowDownIcon {...props} style={{ top: "calc(50% - 12px)" }} />}
  //       id={name}
  //       name={name}
  //       displayEmpty
  //       className={clsx({ placeholder: !formik.values[name] })}
  //       onChange={formik.handleChange}
  //       value={formik.values[name]}
  //       style={{ width: "100%", paddingTop: "16px", paddingBottom: "12px" }}
  //     >
  //       <MenuItem value="" disabled>{defaultLabel}</MenuItem>
  //       {options?.map((item, i) => <MenuItem key={`${name}-${item.value}`} value={item.value}>{item.label}</MenuItem>)}
  //     </Select>

  //     {formik.touched[name] && formik.errors[name]
  //       ? (<span className="form-error">{formik.errors[name]}</span>) : null}
  //   </div>
  // );
};

const FormikForm = (props) => {
  const { children, formik } = props;

  if (!formik) return null;

  return (
    <FormikFormContext.Provider
      value={formik}
    >
      <form onSubmit={formik.handleSubmit}>
        {children}
      </form>
    </FormikFormContext.Provider>
  );
};

FormikForm.Select = FormikSelect;
FormikForm.Input = FormikInput;

export default FormikForm;
